<template>
<div class="fc-page ft-page"><nav aria-label="面包屑"><v-breadcrumbs :items="breadcrumbs" divider="/" class="ft-breadcrumb"/></nav>
<header class="fc-heading"><div class="fc-child-heading"><h1>核销明细查询</h1><p>查询已核销课次，核对课时与消课收入</p></div></header>
<section class="fc-filters" aria-label="核销明细查询筛选"><div class="fc-filter-heading"><h3>筛选条件</h3><span>按条件查询当前校区记录</span></div><form @submit.prevent="selectData"><div class="fc-filter-grid"><div class="fc-filter-cell">
							<v-autocomplete :items="selectClassList" v-model="query.classId" item-text="className"
								item-value="id" label="班级" dense outlined clearable no-data-text="无数据" color="#d9363e" aria-label="班级"></v-autocomplete>
						</div>
<div class="fc-filter-cell">
							<v-select :items="selectTeacherList" v-model="query.teacher" item-text="trueName"
								item-value="id" label="老师" dense outlined clearable color="#d9363e" aria-label="老师"></v-select>
						</div>
<div class="fc-filter-cell">
							<v-select :items="weekItems" v-model="query.weekAt" item-text="weekName"
								item-value="week" label="周几" dense outlined clearable color="#d9363e" aria-label="周几"></v-select>
						</div>
<div class="fc-filter-cell">
							<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
								 transition="scale-transition" offset-y
								min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.start" label="上课开始日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined color="#d9363e" aria-label="上课开始日期"></v-text-field>
								</template>
								<v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn" color="#d9363e">
								</v-date-picker>
							</v-menu>
						</div>
<div class="fc-filter-cell">
							<v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
								 transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="query.end" label="上课结束日期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined color="#d9363e" aria-label="上课结束日期"></v-text-field>
								</template>
								<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn" color="#d9363e">
								</v-date-picker>
							</v-menu>
						</div></div><div class="fc-filter-bottom"><span>设置条件后点击查询</span><div class="fc-filter-actions"><v-btn type="submit" depressed color="#d9363e" dark :loading="query.loading"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></div></form></section>
<section class="fc-records" aria-label="核销明细"><div class="fc-list-heading"><h3>核销明细</h3><span class="fc-count">共 <strong>{{data.total}}</strong> 条</span></div><v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="fc-table ft-table ft-approved_record_list"
			disable-pagination hide-default-footer item-key="id" loading-text="正在加载，请稍候…" :mobile-breakpoint="0" no-data-text="暂无符合条件的记录">

			<template v-slot:item.status="{item}">
				{{ statusName(item.status) }}
			</template>
			<template v-slot:item.timeRange="{item}">
				{{ item.timeFrom }} - {{item.timeTo}}
			</template>
			<template v-slot:item.weekAt="{item}">
				{{ weekName(item.weekAt) }}
			</template>
			<template v-slot:item.approveConsumeType="{item}">
				<span v-if="item.approveConsumeType==='1'">扣课时</span>
				<span v-if="item.approveConsumeType==='2'">扣金额</span>
			</template>


<template v-slot:item.totalReduceQty="{item}"><span class="fc-number">{{item.totalReduceQty}}</span></template>
<template v-slot:item.totalReduceFee="{item}"><span class="fc-number">{{item.totalReduceFee}}</span></template>
<template v-slot:item.totalRevenue="{item}"><span class="fc-number">{{item.totalRevenue}}</span></template>
</v-data-table><div class="fc-pagination"><div class="fc-page-size"><v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
						outlined v-model="query.size" /><span>条 / 页</span><span class="fc-total">共 {{data.total}} 条</span></div><v-pagination v-if="Math.ceil(data.total/query.size)>0" :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange" :total-visible="7" v-model="query.page" color="#d9363e"/></div></section>
</div>
</template>

<script>
	import global from "../../../config/global"
	import utils from "../../../config/utils"
	export default {
		name: "approved-record-list",
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				global:global,
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '财务中心',
						disabled: true
					},
					{
						text: '核销明细查询',
						disabled: true
					},
				],
				data: {
					total: 0,
					headers: [
						{
							text: '课程',
							value: 'courseName',
							sortable: false
						},
						{
							text: '班级',
							value: 'className',
							sortable: false
						},
						{
							text: '老师',
							value: 'teacherName',
							sortable: false
						},
						{
							text: '上课日期',
							value: 'classDate',
							sortable: false
						},
						{
							text: '周几',
							value: 'weekAt',
							sortable: false
						},
						{
							text: '上课时段',
							value: 'timeRange',
							sortable: false
						},
						
						{
							text: '扣费方式',
							value: 'approveConsumeType',
							sortable: false
						},
						{
							text: '应/实/假/旷',
							value: 'unionCount',
							sortable: false
						},
						{
							text: '消课时',
							value: 'totalReduceQty',
							sortable: false
						},
						{
							text: '消学费',
							value: 'totalReduceFee',
							sortable: false
						},
						{
							text: '消课收入',
							value: 'totalRevenue',
							sortable: false
						},
						{
							text: '核销时间',
							value: 'updateAt',
							sortable: false
						},
					],
					list: [],
				},
				selectCourseList: [], //选择课程数据源
				selectClassList: [], //选择课程数据源
				selectTeacherList: [], //选择老师数据源
				weekItems:global.weekList,
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					classId: "",
					teacher: "",
					weekAt:""
				},
			}
		},
		created() {
			// 获取门店列表
			this.getTableDataList();
			const shopId = utils.getCurrentShopId();
			
			this.getClassListForSelect(shopId);
			this.getTeacherListForSelect(shopId);
		},
		methods: {
			selectData(){
				this.query.page = 1;
				this.getTableDataList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			getTableDataList() {
				const that = this;
				this.query.loading = true;
				
				const shopId = utils.getCurrentShopId();

				let url = `/edu/class/record/list/page/${that.query.page - 1}/size/${that.query.size}?v=1&status=2`;
				if (shopId) {
					url += "&shopId=" + shopId;
				}
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.classId) {
					url += "&classId=" + this.query.classId;
				}
				if (this.query.teacher) {
					url += "&teacher=" + this.query.teacher;
				}
				if (this.query.weekAt) {
					url += "&weekAt=" + this.query.weekAt;
				}
				
				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}else if (response.data["code"] === 7031){
						// 调整到登录页
						that.$router.push('/login');
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			weekName(wk) {

				let stName = "未知";
				this.weekItems.forEach((item,index)=>{
					if (item.week == wk){
						stName = item.weekName;
						
					}
				})
				return stName;
			},
			statusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "待核销";
				} else if (state === "0") {
					stName = "已取消";
				}else if (state === "2") {
					stName = "已核销";
				}else if (state === "3") {
					stName = "已顺延";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "info";
				} else if (state === "0") {
					color = "error";
				}else if (state === "2") {
					color = "success";
				}else if (state === "3") {
					color = "grey";
				}

				return color;
			},
			
			consumeTypeName(state){
				let color = "未知";
				if (state === "1") {
					color = "扣课时";
				} else if (state === "2") {
					color = "扣金额";
				}
				
				return color;
			},
			getClassListForSelect(shopId) {

				if (!shopId) {
					return
				}

				const that = this;
				let url = `/edu/shop/class/list/` + shopId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectClassList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getCourseListForSelect(shopId){
				
				if (!shopId){
					return
				}
				
				const that = this;
				let url = `/edu/shop/course/list/`+shopId;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectCourseList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getTeacherListForSelect(shopId){
				
				if (!shopId){
					return
				}
				
				const that = this;
				let url = `/edu/shop/teacher/list/`+shopId;
			
				this.axios.get(url).then(response => {
				
					if (response.data["code"] === 200) {
						that.selectTeacherList = response.data["data"] ? response.data["data"] : [];
						return
					}
					
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
		}
	}
</script>

<style lang="scss" scoped src="../../../assets/styles/financial-tools.scss"></style>
